import { useGoogleReCaptcha } from '@google-recaptcha/react';
import { notification } from 'antd';
import { useTranslation } from 'react-i18next';

export function useRecaptcha(action: string = 'login') {
  const googleReCaptcha = useGoogleReCaptcha();
  const { executeV3: executeRecaptcha } = googleReCaptcha;
  const { t } = useTranslation();
  async function getRecaptchaToken() {
    if (!executeRecaptcha) {
      notification.warning({
        message: 'reCAPTCHA is still loading',
        description: t('please_wait_a_moment_and_try_again_if_issue_continues_refresh'),
      });
      return;
    }
    try {
      const token = await executeRecaptcha(action);
      return token;
    } catch {
      notification.error({
        message: 'Unable to verify reCAPTCHA',
        description: t('something_went_wrong_while_generating_security_token_please_try_again'),
      });
      return null;
    }
  }

  return { getRecaptchaToken, googleReCaptcha };
}
